import httpManager from "@/app/shared/utils/httpManager";

export async function fetchTicketsChartSummary({
  entity = "",
  portfolio = null,
  date_start = "",
  date_end = "",
  queue = null,
}) {
  let url = `/dashboard/?entity=${entity}&date_start=${date_start}&date_end=${date_end}`;
  if (portfolio) {
    url += `&portfolio=${portfolio}`;
  }
  if (queue) {
    url += `&queue=${queue}`;
  }
  const response = await httpManager.get(url);

  return response.data;
}
